<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>

    export default {

        props: ['step'],

        provide() {
            return {
                stepperState: this.sharedState
            }
        },

        data: function () {
            return {
                sharedState: {
                    active: this.step,
                }
            };
        },
    }

</script>
